
import React from "react";
import "@fontsource/dancing-script";

interface LogoProps {
  className?: string;
  imagePath?: string;
  horizontal?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className, imagePath, horizontal = false }) => {
  // Using the provided Grade Test Pro logo URL
  const logoUrl = "https://n-micro.ca/images/gradetestpro.png"; 
  
  return (
    <div className={`flex ${horizontal ? "flex-row items-center" : "flex-col items-center"} ${className || ""}`}>
      <img 
        src={imagePath || logoUrl} 
        alt="Grade Test Pro Logo" 
        className={`${horizontal ? "mr-3" : ""} rounded-full`}
        width={64}
        height={64}
      />
      <div className={`${horizontal ? "" : "mt-2"} font-bold text-lg flex items-center`}>
        <span className="font-['Dancing_Script'] text-2xl text-primary">Grade</span>
        <span className="ml-1.5 bg-blue-600 text-white px-2 py-0.5 rounded-md">Test Pro</span>
      </div>
    </div>
  );
};

export default Logo;
